module.exports = __webpack_public_path__ + "img/client-14.da3d02f0.png";